// LEGAL-LANE (fix 2) — the export-side counterpart to importCells.mjs.
// PURE: no React/DOM/network, so the recording harness imports the same code
// the browser runs.
//
// Excel caps a single cell at 32767 characters and SheetJS ENFORCES it by
// throwing ("Text length must not exceed 32767 characters") from
// json_to_sheet/write. Inside a button's onClick that throw is swallowed by
// React to the console: no file, no toast, no clue — the "the Export button
// does nothing" report. Any column built with JSON.stringify over a collection
// is unbounded by construction and will eventually cross the line.
//
// The cure is not to truncate silently — this is money-adjacent data. A clamped
// cell says so, in the cell, so a reader can never mistake a shortened value for
// a complete one.

export const XLSX_CELL_MAX = 32767;

// Marker appended to a clamped cell. Kept short and unambiguous; the character
// count it reports is of the ORIGINAL value, so the reader knows what is missing.
const MARK = (n) => `…[truncated, ${n} chars total]`;

// Clamp one cell value. Non-strings pass through untouched (numbers, booleans,
// null, Date — SheetJS handles those and none of them can exceed the cap).
export function xlsxCell(v) {
  if (typeof v !== "string" || v.length <= XLSX_CELL_MAX) return v;
  const mark = MARK(v.length);
  return v.slice(0, XLSX_CELL_MAX - mark.length) + mark;
}

// Clamp every cell of a row object. Use as `rows.map(xlsxRow)` immediately
// before json_to_sheet.
export function xlsxRow(row) {
  if (!row || typeof row !== "object") return row;
  const out = {};
  for (const k of Object.keys(row)) out[k] = xlsxCell(row[k]);
  return out;
}

// Clamp every cell of an array-of-arrays sheet. Use as `xlsxAoa(data)`
// immediately before aoa_to_sheet — the shape the Reports exports and both
// server workbooks build.
export function xlsxAoa(aoa) {
  if (!Array.isArray(aoa)) return aoa;
  return aoa.map((row) => (Array.isArray(row) ? row.map(xlsxCell) : xlsxCell(row)));
}
